// extracted by mini-css-extract-plugin
export default {"modalOverlay":"BD-z","modalContent":"CD-z","header":"DD-z","close":"ED-z"};